import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postMobile1, postMobile2 } from "../../common/redux/MasterLayoutCRUD";
import { sportSlice } from "./SportSlice";

const { actions } = sportSlice;

export const getSportGameList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return postMobile2(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.sportGameListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchSportGameList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const clearSportGameList = () => (dispatch) => {
  dispatch(actions.clearSportGameList());
};

export const clearPromotion = () => (dispatch) => {
  dispatch(actions.clearPromotion());
};

export const playGame = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postMobile1(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.playCompanyGame({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: companyPlayGame");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
